import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-vlasnyi-rakhunok-block',
  templateUrl: './vlasnyi-rakhunok-block.component.html',
  styleUrls: ['./vlasnyi-rakhunok-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VlasnyiRakhunokBlockComponent { }
